export const constants = {
  USER_DATA: "user data",
};

export const Roles = {
  MAKER: "maker",
  CHECKER: "checker",
  REGIONAL_ADMIN: "regional_admin",
  GLOBAL_ADMIN: "global_admin",
  SYSTEM_ADMIN: "system_admin",
  COA_VIEWER: "coa_viewer",
  COA_MANAGER: "coa_manager",
  // Stackable with any other role (typically GLOBAL_ADMIN) to grant
  // read-only access into DimeRec's Manage view and DimeXplain's deep-dive,
  // for records the holder isn't the assigned maker/checker of.
  RECORDS_VIEWER: "records_viewer",
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PASSWORD_REGEX =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

export const VALID_FONT_FORMAT = "ttf,otf,woff,woff2,eot,svg,dfont,pfb,pfm";

export const graphColors: Record<string, string> = {
  prepared: "#ffc456",
  not_prepared: "#05a8e3",
  approved: "green",
  not_approved: "orange",
  rejected: "red",
  "Not Specified": "red",
  not_explained: "#ffc456",
  explained: "#05a8e3",
  not_xplained: "#ffc456",
  xplained: "#05a8e3",
  not_allocated: "#05a8e3",
  allocated: "#ffc456",
};

// Hue equivalents of the literal colour values used in graphColors above,
// keyed by that same colour string — so any dataset that already carries a
// `backgroundColor: graphColors[key]` value can look its hue up directly
// (`graphColorHueByValue[ds.backgroundColor]`) without needing the raw key
// at the point the chart is rendered. Used by MountainAreaChart /
// GlowDonutChart to keep the existing colour identity (amber for prepared/
// explained/allocated, blue for their opposites, green/orange/red for
// checker approve-reject) when swapping a flat recharts fill for the
// hue-based gradient treatment.
export const graphColorHueByValue: Record<string, number> = {
  "#ffc456": 39,
  "#05a8e3": 196,
  green: 120,
  orange: 39,
  red: 0,
  "#F87171": 0,
  "#4ADE80": 142,
};

// Explicit, position-based palette shared by every donut in the
// consolidated status-ratio row (Prepared/Not-Prepared, Allocated/
// Not-Allocated, Approved/Not-Approved/Rejected) so all three always
// render the exact same gold/blue family regardless of which status
// strings a given API response happens to return — rather than each
// donut indirectly landing on whatever colour graphColorHueByValue maps
// its own backgroundColor to. First two hues match graphColors.prepared
// (#ffc456) / graphColors.not_prepared (#05a8e3) exactly; the third
// (muted rose) only applies to a donut with 3 segments.
export const STATUS_RATIO_HUES = [39, 196, 350];
